import React from "react";

export default ({
  selectedTrackFilter,
  onSelectFilter,
  selectedResource,
  onChangeResource
}) => {
  let c = "btn btn-outline-primary";
  return (
    <div className="container my-3">
      <div className="row tracks">
        <div className="col-66 left-tracks pl-0">
          <div className="btn-group-toggle btn-group mr-2">
            <button
              onClick={() => onSelectFilter("-play_count")}
              className={
                c + (selectedTrackFilter === "-play_count" ? " active" : "")
              }
            >
              plays
            </button>
          </div>
          <div className="btn-group-toggle btn-group mr-2">
            <button
              onClick={() => onSelectFilter("-release_date")}
              className={
                c + (selectedTrackFilter === "-release_date" ? " active" : "")
              }
            >
              release date
            </button>
          </div>
          <div className="btn-group-toggle btn-group mr-2">
            <button
              onClick={() => onSelectFilter("title")}
              className={c + (selectedTrackFilter === "title" ? " active" : "")}
            >
              alphabetical
            </button>
          </div>
        </div>
        <div className="col right-tracks text-right">
          <div className="btn-group-toggle btn-group mr-0 disabled">
            <button
              onClick={() => onChangeResource("SoundTrack")}
              className={`btn btn-outline-secondary ${
                selectedResource === "SoundTrack" ? "active" : ""
              }`}
            >
              <span className="position-relative" style={{ left: "4px" }}>
                song
              </span>
            </button>
            <button
              onClick={() => onChangeResource("Album")}
              className={`btn btn-outline-secondary ${
                selectedResource === "Album" ? "active" : ""
              }`}
            >
              album
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
